import React from 'react'
import { X } from 'lucide-react'
import { Button } from './button'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  children: React.ReactNode
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

export function Modal({ isOpen, onClose, title, children, size = 'md' }: ModalProps) {
  if (!isOpen) return null

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl'
  }

  return (
    <div className="fixed inset-0 z-[80] flex items-end justify-center bg-slate-950/55 p-0 backdrop-blur-[2px] lg:items-center lg:p-4">
      <div className={`flex max-h-[92dvh] w-full flex-col overflow-hidden rounded-t-3xl border border-border/80 bg-card shadow-2xl lg:max-h-[90vh] lg:rounded-2xl ${sizeClasses[size]}`}>
        <div className="flex items-center justify-between border-b p-4 lg:p-6">
          <h2 className="text-lg font-semibold">{title}</h2>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <X className="h-4 w-4" />
          </Button>
        </div>
        <div className="max-h-[calc(92dvh-4.5rem)] overflow-y-auto p-4 lg:max-h-[calc(90vh-120px)] lg:p-6">
          {children}
        </div>
      </div>
    </div>
  )
}
